/**
 * App theme colors - light blue theme
 */
export const themeColors = {
    primary: '#0EA5E9',           // Sky blue - main buttons, links, accents
    primaryHover: '#0284C7',      // Darker blue - hover state
    primaryActive: '#0369A1',     // Deep blue - active/selected
    primaryLight: 'rgba(14, 165, 233, 0.1)',  // Light background on hover
    primaryShadow: 'rgba(14, 165, 233, 0.35)',
} as const;
